import { createJSONStorage } from 'zustand/middleware';
import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

const TEN_DLC_BANNER_STORE_KEY = 'TenDLCBannerStore';

type TenDLCBannerStore = {
  dismissedLocationIds: string[];
  dismissLocationIds: (locationIds: string[]) => void;
};

export const useTenDLCBannerStore = createStoreWithPersistAndSubscribe<TenDLCBannerStore>(
  (set) => ({
    dismissedLocationIds: [],
    dismissLocationIds: (locationIds) => {
      set((state) => ({
        ...state,
        dismissedLocationIds: Array.from(new Set([...state.dismissedLocationIds, ...locationIds])),
      }));
    },
  }),
  { name: TEN_DLC_BANNER_STORE_KEY, version: 0, storage: createJSONStorage(() => sessionStorage) },
  { name: 'TenDLCBannerStore', trace: true }
);

export const useTenDLCBannerShallowStore = createShallowStore;
